var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoughnut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11598_53694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99975 14.4756C7.46469 16.5648 8.04867 18.8741 9.7259 20.4619C10.9646 21.6346 12.5637 22.1903 14.1438 22.1394C15.39 22.0993 16.6243 21.6818 17.6608 20.8922C18.1001 20.5574 18.7289 20.5321 19.1299 20.9118L20.8449 22.5353C21.246 22.915 21.2662 23.5521 20.8505 23.9157C19.0175 25.5192 16.7508 26.3816 14.4508 26.492C11.6942 26.6244 8.88984 25.6764 6.72741 23.6293C3.78985 20.8483 2.81284 16.7735 3.84373 13.1338M7.99975 14.4756C8.25008 13.4981 8.74537 12.5688 9.48824 11.7841C11.5858 9.5684 14.9424 9.26059 17.3875 10.9201C17.8445 11.2302 18.4739 11.2213 18.8536 10.8202L20.4771 9.10528C20.8568 8.70421 20.8419 8.06669 20.4069 7.72637C16.1901 4.42712 10.076 4.81905 6.3209 8.7856C5.11513 10.0593 4.2907 11.5556 3.84373 13.1338M7.99975 14.4756L3.84373 13.1338",
    stroke: "#BFBFBF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0828 21.4594C25.5037 21.817 26.1406 21.7681 26.4487 21.3097C28.7293 17.9168 28.3596 13.3716 25.5607 10.3918C25.1826 9.98926 24.5463 10.0439 24.1887 10.4648L23.1169 11.7264C22.7593 12.1473 22.8205 12.7735 23.1649 13.2052C24.4635 14.8336 24.6481 17.1036 23.6297 18.9204C23.3596 19.4022 23.4004 20.03 23.8213 20.3876L25.0828 21.4594Z",
    stroke: "#CE375C",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11598_53694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoughnut);
export default __webpack_public_path__ + "static/media/doughnut.5de473b7c70893abc1450a7272421be1.svg";
export { ForwardRef as ReactComponent };